import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, Heart, Rocket } from 'lucide-react';
const timeline = [{
  phase: 'Now',
  title: 'ERA PILOT',
  active: true
}, {
  phase: 'Next',
  title: 'POST-ERA STORY',
  active: false
}, {
  phase: 'Quarterly',
  title: 'EMPLOYEE PULSES',
  active: false
}, {
  phase: 'Ongoing',
  title: 'ALWAYS-ON ENGINE',
  active: false
}];
const framework = [{
  icon: Sparkles,
  label: 'Attract',
  desc: 'Show CSL Vifor as a company with purpose, science, people, and momentum.'
}, {
  icon: Heart,
  label: 'Retain',
  desc: 'Make employees feel seen, heard, and part of the story.'
}, {
  icon: Rocket,
  label: 'Mobilize',
  desc: 'Turn passive internal communication into active participation and forward energy.'
}];
export const Slide08Future = () => {
  return <div className="relative w-full h-full flex flex-col bg-slate-950 overflow-hidden px-24 py-14" data-id="element-215">
      <div className="absolute inset-0 bg-gradient-to-t from-red-950/30 via-slate-950 to-slate-950" data-id="element-216" />
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[900px] h-[500px] bg-red-700/15 rounded-full blur-[140px]" data-id="element-217" />

      <div className="relative z-10 h-full flex flex-col" data-id="element-218">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} data-id="element-219">
          <div className="flex items-center space-x-3 mb-4" data-id="element-220">
            <div className="h-[1px] w-8 bg-red-600" data-id="element-221" />
            <span className="text-red-500 font-semibold tracking-widest uppercase text-xs" data-id="element-222">
              08 — Future State
            </span>
          </div>
          <h2 className="text-5xl font-bold tracking-tight text-white leading-tight" data-id="element-223">
            Start small.{' '}
            <span className="text-red-500" data-id="element-224">Build strategically.</span>
          </h2>
        </motion.div>

        {/* Framework — the central value proposition */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.3,
        duration: 0.8
      }} className="mt-10" data-id="element-225">
          <div className="flex items-baseline space-x-4 mb-6" data-id="element-226">
            <span className="text-xs uppercase tracking-[0.3em] text-slate-500" data-id="element-227">
              The Framework
            </span>
            <div className="flex-1 h-[1px] bg-slate-800" data-id="element-228" />
          </div>

          <div className="grid grid-cols-3 gap-6" data-id="element-229">
            {framework.map((item, index) => {
            const Icon = item.icon;
            return <motion.div key={item.label} initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: 0.5 + index * 0.15,
              duration: 0.6
            }} className="relative bg-slate-900/40 border border-slate-800 rounded-2xl p-6 hover:border-red-500/40 transition-colors group" data-id="element-230">
                  <div className="absolute top-0 left-6 -translate-y-1/2 px-2 py-0.5 bg-red-600 rounded text-[10px] font-bold tracking-widest uppercase text-white" data-id="element-231">
                    0{index + 1}
                  </div>
                  <div className="flex items-center space-x-3 mb-3 mt-1" data-id="element-232">
                    <Icon className="w-6 h-6 text-red-500" strokeWidth={1.5} data-id="element-233" />
                    <h3 className="text-3xl font-bold text-white tracking-tight" data-id="element-234">
                      {item.label}.
                    </h3>
                  </div>
                  <p className="text-sm text-slate-400 font-light leading-relaxed" data-id="element-235">
                    {item.desc}
                  </p>
                </motion.div>;
          })}
          </div>
        </motion.div>

        {/* Timeline */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 1,
        duration: 0.8
      }} className="mt-10 mb-8" data-id="element-236">
          <div className="flex items-baseline space-x-4 mb-6" data-id="element-237">
            <span className="text-xs uppercase tracking-[0.3em] text-slate-500" data-id="element-238">
              The Path
            </span>
            <div className="flex-1 h-[1px] bg-slate-800" data-id="element-239" />
          </div>

          <div className="relative grid grid-cols-4 gap-4" data-id="element-240">
            {/* Timeline line */}
            <div className="absolute top-2 left-[12.5%] right-[12.5%] h-[2px] bg-gradient-to-r from-red-600 via-red-700/40 to-slate-800" data-id="element-241" />

            {timeline.map((item, index) => <motion.div key={item.title} initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 1.2 + index * 0.12,
            duration: 0.5
          }} className="relative flex flex-col items-center text-center" data-id="element-242">
                <div className={`w-4 h-4 rounded-full mb-4 relative z-10 ${item.active ? 'bg-red-500 shadow-[0_0_20px_rgba(220,38,38,0.8)]' : 'bg-slate-700 border border-slate-600'}`} data-id="element-243">
                  {item.active && <div className="absolute inset-0 rounded-full bg-red-500 animate-ping opacity-60" data-id="element-244" />}
                </div>
                <span className="text-[10px] font-semibold text-red-500 tracking-[0.25em] uppercase mb-1" data-id="element-245">
                  {item.phase}
                </span>
                <h3 className={`text-sm font-bold tracking-wide ${item.active ? 'text-white' : 'text-slate-500'}`} data-id="element-246">
                  {item.title}
                </h3>
              </motion.div>)}
          </div>
        </motion.div>

        {/* Closing statement */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 1.8,
        duration: 1
      }} className="mt-auto border-t border-slate-800 pt-6 text-center" data-id="element-247">
          <p className="text-2xl font-light text-white" data-id="element-248">
            <span className="text-slate-400" data-id="element-249">ERA is not the destination.</span>{' '}
            <span className="font-semibold text-transparent bg-clip-text bg-gradient-to-r from-red-400 to-red-600" data-id="element-250">
              It’s the ignition point.
            </span>
          </p>
        </motion.div>
      </div>
    </div>;
};